import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Button,
  Label,
  Icon,
  Confirm,
  Loader
} from 'semantic-ui-react';
import { reportScheduleActions } from '../../actions/reportSchedule.actions';
import { reportScheduleKindOptions, reportScheduleFrequencyOptions, weekDayOptions } from '../../constants/reportSchedule.constants';
import { history } from '../../helpers';
import { userConstants } from '../../constants/user.constants';
import moment from 'moment';

function labelFor(options, value) {
  const option = options.find(o => o.value === value);
  return option ? option.text : value;
}

function summarizeSchedule(item) {
  const frequency = labelFor(reportScheduleFrequencyOptions, item.Frequency);
  const when = item.Frequency === 0
    ? labelFor(weekDayOptions, item.DayOfWeek)
    : `dia ${item.DayOfMonth}`;
  return `${frequency}, ${when}, às ${String(item.HourOfDay).padStart(2, '0')}:00`;
}

class ReportScheduleIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmOpen: false,
      confirmSchedule: null,
    };
  }

  componentDidMount() {
    this.fetchSchedules();
  }

  fetchSchedules() {
    const { dispatch } = this.props;
    dispatch(reportScheduleActions.fetch());
  }

  showConfirm(schedule) {
    this.setState({ confirmOpen: true, confirmSchedule: schedule });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false, confirmSchedule: null });
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmSchedule } = this.state;
    dispatch(reportScheduleActions.remove(confirmSchedule.Id)).then(() => this.fetchSchedules());
    this.setState({ confirmOpen: false, confirmSchedule: null });
  }

  runNow(schedule) {
    if (window.confirm(`Enviar agora o relatório "${schedule.Name}"?`)) {
      const { dispatch } = this.props;
      dispatch(reportScheduleActions.run(schedule.Id));
    }
  }

  render() {
    const { schedules, loading, me } = this.props;

    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }

    return (
      <Fragment>
        <Confirm
          open={this.state.confirmOpen}
          content={this.state.confirmSchedule ? `Tem certeza que deseja remover o agendamento "${this.state.confirmSchedule.Name}"?` : ''}
          onCancel={() => this.closeConfirm()}
          onConfirm={() => this.executeConfirm()}
        />
        <Loader active={loading} />
        <div style={{ textAlign: "right", marginBottom: "8px" }}>
          <Button primary onClick={() => history.push('/report-schedule/create')}>Novo Agendamento</Button>
        </div>
        <Card.Group>
          {(!schedules || (schedules.Results && schedules.TotalNumberOfRecords === 0)) &&
            <Card header='Nenhum agendamento' fluid />
          }

          {schedules && schedules.Results && schedules.Results.map((item) => {
            return <Card key={item.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {item.Name}
                  <Label style={{ float: "right" }} color={item.Enabled ? 'green' : 'red'}>
                    {item.Enabled ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Description>
                  <p><strong>Relatório:</strong> {labelFor(reportScheduleKindOptions, item.Kind)}</p>
                  <p><strong>Envio:</strong> {summarizeSchedule(item)}</p>
                  {item.RecipientsCsv && <p><strong>Destinatários:</strong> {item.RecipientsCsv}</p>}
                  <p><strong>Última Execução:</strong> {item.LastRunAt ? moment(item.LastRunAt).format('DD/MM/YYYY HH:mm') : 'Nunca'}</p>
                  {item.LastError && <p style={{ color: 'red' }}><strong>Último Erro:</strong> {item.LastError}</p>}
                </Card.Description>
              </Card.Content>
              <Card.Content extra>
                <Button size='mini' icon onClick={() => this.runNow(item)}>
                  <Icon name='send' />
                  Executar Agora
                </Button>

                <Button size='mini' secondary icon onClick={() => history.push(`/report-schedule/update/${item.Id}`)}>
                  <Icon name='edit' />
                  Alterar
                </Button>

                <Button size='mini' color='red' icon onClick={() => this.showConfirm(item)}>
                  <Icon name='trash' />
                  Excluir
                </Button>
              </Card.Content>
            </Card>
          })}
        </Card.Group>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { reportSchedule, users } = state;
  return {
    schedules: reportSchedule.schedules || null,
    loading: reportSchedule.loading,
    me: users.me || null
  };
}

const connectedReportScheduleIndexScreen = connect(mapStateToProps)(ReportScheduleIndexScreen);
export { connectedReportScheduleIndexScreen as ReportScheduleIndexScreen };
